export default {
	list: 'Issuance',
	columns: {
		Id: {
			class: 'id',
			dataName: 'Id',
			type: 'number',
			title: 'Id',
			width: 100,
			hidden: true
		},
		Status: {
			class: 'choice',
			dataName: 'Status',
			type: 'string',
			title: 'Status',
			width: 100,
			hidden: true,
		},
		WorkflowStatus: {
			class: 'choice',
			dataName: 'WorkflowStatus',
			type: 'string',
			title: 'Status',
			width: 100,
			hidden: false,
			readOnly:true
		},
		ProgramId: {
			class: 'lookup',
			dataName: 'ProgramId',
			type: 'number',
			title: 'Program Id',
			width: 100,
			hidden: true
		},
		ProgramTitle: {
			class: 'lookup',
			dataName: 'Program/Title',
			type: 'string',
			title: 'Program',
			width: 200,
			hidden: false,
			readOnly:true
		},
		ProgramAlias: {
			class: 'lookup',
			dataName: 'Program/Alias',
			type: 'string',
			title: 'Project',
			width: 150,
			hidden: true,
			readOnly:true
		},
		ReceiverId: {
			class: 'lookup',
			dataName: 'ReceiverId',
			type: 'number',
			title: 'Partner Id',
			width: 100,
			hidden: true
		},
		ReceiverFullName: {
			class: 'lookup',
			dataName: 'Receiver/FullName',
			type: 'string',
			title: 'Partner',
			width: 150,
			hidden: false,
			readOnly:true
		},
		UnitClass: {
			class: 'choice',
			dataName: 'UnitClass',
			type: 'string',
			title: 'Unit Class',
			width: 100,
			hidden: false
		},
		UnitType: {
			class: 'choice',
			dataName: 'UnitType',
			type: 'string',
			title: 'Unit Type',
			width: 100,
			hidden: false
		},
		VestingType: {
			class: 'choice',
			dataName: 'VestingType',
			type: 'string',
			title: 'Vesting Type',
			width: 150,
			hidden: false
		},
		UnitPool: {
			class: 'choice',
			dataName: 'UnitPool',
			type: 'string',
			title: 'Unit Pool',
			width: 100,
			hidden: false
		},
		Unit: {
			class: 'value',
			dataName: 'Unit',
			type: 'number',
			title: 'Unit',
			width: 100,
			hidden: false,
			template: '#=kendo.format("{0:n2}", Unit )#',
		},
		TransactionDate: {
			class: 'value',
			dataName: 'TransactionDate',
			type: 'date',
			title: 'Date',
			filterable: true,
			width: 100,
			hidden: false
		},
		Note: {
			class: 'value',
			dataName: 'Note',
			type: 'string',
			title: 'Note',
			width: 100,
			hidden: true
		},
		BusinessEvent: {
			class: 'value',
			dataName: 'BusinessEvent',
			type: 'string',
			title: 'BusinessEvent',
			width: 100,
			hidden: true
		},
		BatchGUID: {
			class: 'value',
			dataName: 'BatchGUID',
			type: 'string',
			title: 'Batch Id',
			width: 100,
			hidden: true
		},
		VestStartDate:{
			class: 'value',
			dataName: 'VestStartDate',
			type: 'date',
			title: 'VestStartDate',
			width: 100,
			hidden: true
		},
		VestYear1Date:{
			class: 'value',
			dataName: 'VestYear1Date',
			type: 'date',
			title: 'VestYear1Date',
			width: 100,
			hidden: true
		},
		VestYear2Date:{
			class: 'value',
			dataName: 'VestYear2Date',
			type: 'date',
			title: 'VestYear2Date',
			width: 100,
			hidden: true
		},
		VestYear3Date:{
			class: 'value',
			dataName: 'VestYear3Date',
			type: 'date',
			title: 'VestYear3Date',
			width: 100,
			hidden: true
		},
		VestYear4Date:{
			class: 'value',
			dataName: 'VestYear4Date',
			type: 'date',
			title: 'VestYear4Date',
			width: 100,
			hidden: true
		},
		VestCliffDate:{
			class: 'value',
			dataName: 'VestCliffDate',
			type: 'date',
			title: 'VestCliffDate',
			width: 100,
			hidden: true
		}
	}
}